import type { WheelEvent as ReactWheelEvent } from 'react'

/**
 * Prevents scroll propagation to parent when the inner container
 * reaches its top or bottom boundary.
 */
export function handleScrollGuard(e: ReactWheelEvent<HTMLElement>) {
  const el = e.currentTarget
  const { scrollTop, scrollHeight, clientHeight } = el
  const atTop = scrollTop <= 0 && e.deltaY < 0
  const atBottom = scrollTop + clientHeight >= scrollHeight - 1 && e.deltaY > 0
  if (atTop || atBottom) e.stopPropagation()
}

export const scrollContainerProps = {
  style: { overscrollBehavior: 'contain' as const, touchAction: 'pan-y' as const },
}
